module.exports = __webpack_public_path__ + "static/media/5.97b90af4.jpg";